module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n        Press the button below to activate this integration, you will be notified as soon as it gets activated.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center mt-3"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "disabled": _vm.isActivating
    },
    on: {
      "click": function($event) {
        return _vm.clickActivate()
      }
    }
  }, [_vm._v("Activate")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bba3ed2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/integrations/integratePopup/popupParts/stateLabelArea/requestActivation.vue
// module id = 2788
// module chunks = 0